export default __webpack_public_path__ + "static/productsans-medium-webfont-caf1429ea7b5b06808658b8f751f2c22.woff";